import React, { useState, useContext, useEffect } from "react";
import { Sidebar } from "../../component/Sidebar/Sidebar";
import { GridDashBoard } from "../../style/Dashboard";
import { Header } from "../../component/Header/Header";
import { Navbar } from "../../component/Navbar/Navbar";
import { Container, CustomLink } from "../../style/Tab";
import Router from "../../Routes";
import { useHistory } from "react-router-dom";
import { verifyAuth } from "../../authverify";

import "./anima.css";
import MedizenCreative from "../../component/NewCreatives/MedizenCreative/MedizenCreative";
import PanazCreative from "../../component/NewCreatives/PanazCreative/PanazCreative";
import PrimeraCreative from "../../component/NewCreatives/PrimeraCreative/PrimeraCreative";
import { ADImage } from "../../style/Header";
import Mycontext from "../../store/Mycontext";
import { My } from "devextreme-react/autocomplete";
import MedizanVerticalAd from "../../../src/assets/Ads/MedizenV.jpg";
import PrimeraVerticalAd from "../../../src/assets/Ads/PrimeraV.jpg";
import PanazVerticalAd from "../../../src/assets/Ads/PanazV.jpg";
import { NEW_AD_CREATIVE, NEW_CREATIVE_LOCATION, creativeConstants, htmls } from "../../constants";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import CustomizePopup from "../../component/Home/CustomizePopup";

// config/sidebarConfig.js
import Cal from "../../assets/sidebar/calendar.svg";
import User from "../../assets/sidebar/user.svg";
import Menu from "../../assets/sidebar/menu.svg";
import Person from "../../assets/sidebar/person.svg";
import CalA from "../../assets/sidebar/calendarA.svg";
import UserA from "../../assets/sidebar/userA.svg";
import MenuA from "../../assets/sidebar/menuA.svg";
import PersonA from "../../assets/sidebar/personA.svg";
import TaskIcon from "../../assets/sidebar/tasklist.svg";
import TaskIconA from "../../assets/sidebar/tasklistA.svg";
import MobileNavbar from "../../component/MobileNav/MobileNav";
import { Grid } from "@material-ui/core";

export const sidebarConfig = [
  {
    path: "/Calender",
    icon: Cal,
    activeIcon: CalA,
    alt: "Cal",
    label: "Calendar",
  },
  {
    path: "/People/dashboard",
    icon: User,
    activeIcon: UserA,
    alt: "User",
    label: "People",
  },
  {
    path: "",
    icon: Menu,
    activeIcon: MenuA,
    alt: "Menu",
    label: "Menu",
  },
  {
    path: "",
    icon: Person,
    activeIcon: PersonA,
    alt: "Person",
    label: "Person",
  },
  {
    path: "/TaskList",
    icon: TaskIcon,
    activeIcon: TaskIconA,
    alt: "TaskList",
    label: "Tasks",
  },
];


export default function People() {
  const randValue = parseInt(window.sessionStorage.getItem("rValue"));
  const [bannerType, setBannerType] = React.useState(null);
  const [drugType, setDrugType] = React.useState();
  const [showAd, setShowAd] = React.useState(false);
  const [pmcTab, setPmcTab] = React.useState(false)
  const adConfig = localStorage.getItem("creativeConfig") ? JSON.parse(localStorage.getItem("creativeConfig")) : null;
  // const showAd = adConfig && adConfig.workflowWithAdds ? adConfig.workflowWithAdds.includes("Login") : false;
  const location = useLocation();
  const [open, setOpen] = useState(false);

  const loginAds = {
    1: <MedizenCreative />,
    2: <PrimeraCreative />,
    3: <PanazCreative />,
  };

  const loginAds1 = {
    1: MedizanVerticalAd,
    2: PrimeraVerticalAd,
    3: PanazVerticalAd,
  }

  const DefaultBanner = (
    <ADImage
      src={"Ads/Horizontal1.jpeg"}
      alt="Advertise"
      width="668px"
      height="90px"
    />
  );

  const randomValue = sessionStorage.getItem("rValue");
  const [selectedBanner, setSelectedBanner] = useState("new_banners");

  const keyToBannerMap = {
    consultation: PanazVerticalAd,
    diagnosis: MedizanVerticalAd,
    prescription: PrimeraVerticalAd,
  };

  const history = useHistory();

  if (!verifyAuth()) {
    history.push({
      pathname: "/",
    });
  }

  const handleLinkClick = (key) => {
  };

  const onBannerChange = (value) => {
    setSelectedBanner(value);
  };

  const getBannerType = () => {
    const len = adConfig ? adConfig.creative_size.length : 0;
    if (len === 0) return null;
    const newRandValue = Math.floor(Math.random() * len);
    return adConfig.creative_size[newRandValue];
  };

  const getRandomHoriCreative = () => {
    const withCta = adConfig ? adConfig.creative_cta === "With CTAs" : null;
    if (!adConfig) return;
    if (withCta) {
      if (randValue === 1) {
        if (adConfig.messaging_sparks.includes("Rep"))
          return htmls.MedizenHoriAddWithCTARep;
        if (adConfig.messaging_sparks.includes("Sample"))
          return htmls.MedizenHoriAddWithCTASample;
        return htmls.MedizenHoriAddWithCta;
      }
      if (randValue === 2) {
        if (adConfig.messaging_sparks.includes("Rep"))
          return htmls.PrimeraHoriAddWithCTARep;
        if (adConfig.messaging_sparks.includes("Sample"))
          return htmls.PrimeraHoriAddWithCTASample;
        return htmls.PrimeraHoriAddWithCTA;
      }
      if (randValue === 3) {
        if (adConfig.messaging_sparks.includes("Sample"))
          return htmls.PanazHoriAddWithCTASample;
        if (adConfig.messaging_sparks.includes("Rep"))
          return htmls.PanazHoriAddWithCTARep;
        return htmls.PanazHoriAddWithCta;
      }
    } else {
      if (randValue === 1) {
        if (adConfig.messaging_sparks.includes("Sample"))
          return htmls.MedizenHoriAddWithoutCTASample;
        if (adConfig.messaging_sparks.includes("Rep"))
          return htmls.MedizenHoriAddWithoutCTARep;
        return htmls.MedizenHoriAddWithoutCTA;
      }
      if (randValue === 2) {
        if (adConfig.messaging_sparks.includes("Rep"))
          return htmls.PrimeraHoriAddWithoutCTARep;
        if (adConfig.messaging_sparks.includes("Sample"))
          return htmls.PrimeraHoriAddWithoutCTASample;
        return htmls.PrimeraHoriAddWithoutCTA;
      }
      if (randValue === 3) {
        if (adConfig.messaging_sparks.includes("Sample"))
          return htmls.PanazHoriAddWithoutCTASample;
        if (adConfig.messaging_sparks.includes("Rep"))
          return htmls.PanazHoriAddWithoutCTARep;
        return htmls.PanazHoriAddWithoutCTA;
      }
    }
    return true;
  };

  const getDrugToShowDashboard = () => {
    if (!adConfig) return;
    const withCta = adConfig ? adConfig.creative_cta === "With CTAs" : null;

    // check all present 
    const allPresent = creativeConstants.messaging_sparks.every((element) => adConfig.messaging_sparks.includes(element));
    if (allPresent) {
      return withCta ? NEW_AD_CREATIVE.PAINFIN : NEW_AD_CREATIVE.PAINFIN_NO_CTA;
    }

    // if any of rep or sample and copay
    const isSecond = ['Rep', 'Copay'].every((element) => adConfig.messaging_sparks.includes(element)) || ['Sample', 'Copay'].every((element) => adConfig.messaging_sparks.includes(element));
    if (isSecond) return withCta ? NEW_AD_CREATIVE.PAINFIN : NEW_AD_CREATIVE.PAINFIN_NO_CTA;

    // if drug, trail and copay all 3 present
    const isThird = ['Drug', 'Trial', 'Copay'].every((element) => adConfig.messaging_sparks.includes(element));
    if (isThird) return withCta ? NEW_AD_CREATIVE.PSORIASIS_TRAIL : NEW_AD_CREATIVE.PSORIASIS_TRAIL_NO_CTA;

    // if only clinical and copay
    const isFourth = ['Drug', 'Copay'].every((element) => adConfig.messaging_sparks.includes(element));
    if (isFourth) return withCta ? NEW_AD_CREATIVE.CARE_DURA : NEW_AD_CREATIVE.CARE_DURA_NO_CTA

    if(adConfig.messaging_sparks.includes('Drug')) return withCta ? NEW_AD_CREATIVE.CARE_DURA : NEW_AD_CREATIVE.CARE_DURA_NO_CTA

    return withCta ? NEW_AD_CREATIVE.PSORIASIS_TRAIL : NEW_AD_CREATIVE.PSORIASIS_TRAIL_NO_CTA;
  }

  const getDrugToShowConsultation = () => {
    if (!adConfig) return;
    const withCta = adConfig ? adConfig.creative_cta === "With CTAs" : null;

    // check all present 
    const allPresent = creativeConstants.messaging_sparks.every((element) => adConfig.messaging_sparks.includes(element));
    if (allPresent) return withCta ? NEW_AD_CREATIVE.PAINFIN : NEW_AD_CREATIVE.PAINFIN_NO_CTA;

    // if any of rep or sample and copay
    const isSecond = ['Rep', 'Copay'].every((element) => adConfig.messaging_sparks.includes(element)) || ['Sample', 'Copay'].every((element) => adConfig.messaging_sparks.includes(element));
    if (isSecond) return withCta ? NEW_AD_CREATIVE.PAINFIN : NEW_AD_CREATIVE.PAINFIN_NO_CTA;

    // if drug, trail and copay all 3 present
    const isThird = ['Drug', 'Trial', 'Copay'].every((element) => adConfig.messaging_sparks.includes(element));
    if (isThird) return withCta ? NEW_AD_CREATIVE.PSORIASIS_TRAIL : NEW_AD_CREATIVE.PSORIASIS_TRAIL_NO_CTA;

    // if only clinical and copay
    const isFourth = ['Drug', 'Copay'].every((element) => adConfig.messaging_sparks.includes(element));
    if (isFourth) return withCta ? NEW_AD_CREATIVE.CARE_DURA : NEW_AD_CREATIVE.CARE_DURA_NO_CTA

    if(adConfig.messaging_sparks.includes('Drug')) return withCta ? NEW_AD_CREATIVE.CARE_DURA : NEW_AD_CREATIVE.CARE_DURA_NO_CTA

    return withCta ? NEW_AD_CREATIVE.PSORIASIS_TRAIL : NEW_AD_CREATIVE.PSORIASIS_TRAIL_NO_CTA;
  }

  const getRandomVertCreative = () => {
    const withCta = adConfig ? adConfig.creative_cta === "With CTAs" : null;
    if (!adConfig) return;
    if (location.pathname === "/People/dashboard" || (location.pathname === '/People/Consultation' && selectedBanner === 'new_banners') || randValue == 0) {
      // return `<img src='${NEW_CREATIVE_LOCATION[drugType].vertical}' style='width:300px;height:600px;' />`;
      return NEW_CREATIVE_LOCATION[drugType].vertical;
    }

    if (withCta) {
      if (randValue === 1) {
        if (adConfig.messaging_sparks.includes("Rep"))
          return htmls.MedizenVertAddWithCTARep;
        if (adConfig.messaging_sparks.includes("Sample"))
          return htmls.MedizenVertAddWithCTASample;
        return htmls.MedizenVertAddWithCta;
      }
      if (randValue === 2) {
        if (adConfig.messaging_sparks.includes("Sample"))
          return htmls.PrimeraVertAddWithCTASample;
        if (adConfig.messaging_sparks.includes("Rep"))
          return htmls.PrimeraVertAddWithCTARep;
        return htmls.PrimeraVertAddWithCTA;
      }
      if (randValue === 3) {
        if (adConfig.messaging_sparks.includes("Rep"))
          return htmls.PanazVertAddWithCTARep;
        if (adConfig.messaging_sparks.includes("Sample"))
          return htmls.PanazVertAddWithCTASample;
        return htmls.PanazVertAddWithCta;
      }
    } else {
      if (randValue === 1) {
        if (adConfig.messaging_sparks.includes("Sample"))
          return htmls.MedizenVertAddWithoutCTASample;
        if (adConfig.messaging_sparks.includes("Rep"))
          return htmls.MedizenVertAddWithoutCTARep;
        return htmls.MedizenVertAddWithoutCTA;
      }
      if (randValue === 2) {
        if (adConfig.messaging_sparks.includes("Rep"))
          return htmls.PrimeraVertAddWithoutCTARep;
        if (adConfig.messaging_sparks.includes("Sample"))
          return htmls.PrimeraVertAddWithoutCTASample;
        return htmls.PrimeraVertAddWithoutCTA;
      }
      if (randValue === 3) {
        if (adConfig.messaging_sparks.includes("Sample"))
          return htmls.PanazVertAddWithoutCTASample;
        if (adConfig.messaging_sparks.includes("Rep"))
          return htmls.PanazVertAddWithoutCTARep;
        return htmls.PanazVertAddWithoutCTA;
      }
    }
  };
  const getRandomReactCreative = () => {
    const withCta = adConfig ? adConfig.creative_cta === "With CTAs" : null;
    if (!adConfig) return;
    if (location.pathname === "/People/dashboard" || (location.pathname === '/People/Consultation' && selectedBanner === 'new_banners') || randValue == 0) {
      // return `<img src='${NEW_CREATIVE_LOCATION[drugType].square}' style='width:300px;height:250px;' />`;
      return NEW_CREATIVE_LOCATION[drugType].square;
    }

    if (withCta) {
      if (randValue === 1) {
        if (adConfig.messaging_sparks.includes("Rep"))
          return htmls.MedizenReactAddWithCTARep;
        if (adConfig.messaging_sparks.includes("Sample"))
          return htmls.MedizenReactAddWithCTASample;
        return htmls.MedizenRectAddWithCta;
      }
      if (randValue === 2) {
        if (adConfig.messaging_sparks.includes("Sample"))
          return htmls.PrimeraReactAddWithCTASample;
        if (adConfig.messaging_sparks.includes("Rep"))
          return htmls.PrimeraReactAddWithCTARep;
        return htmls.PrimeraReactAddWithCTA;
      }
      if (randValue === 3) {
        if (adConfig.messaging_sparks.includes("Rep"))
          return htmls.PanazReactAddWithCTARep;
        if (adConfig.messaging_sparks.includes("Sample"))
          return htmls.PanazReactAddWithCTASample;
        return htmls.PanazReactAddWithCta;
      }
    } else {
      if (randValue === 1) {
        if (adConfig.messaging_sparks.includes("Sample"))
          return htmls.MedizenReactAddWithoutCTASample;
        if (adConfig.messaging_sparks.includes("Rep"))
          return htmls.MedizenReactAddWithoutCTARep;
        return htmls.MedizenReactAddWithoutCTA;
      }
      if (randValue === 2) {
        if (adConfig.messaging_sparks.includes("Rep"))
          return htmls.PrimeraReactAddWithoutCTARep;
        if (adConfig.messaging_sparks.includes("Sample"))
          return htmls.PrimeraReactAddWithoutCTASample;
        return htmls.PrimeraReactAddWithoutCTA;
      }
      if (randValue === 3) {
        if (adConfig.messaging_sparks.includes("Sample"))
          return htmls.PanazReactAddWithoutCTASample;
        if (adConfig.messaging_sparks.includes("Rep"))
          return htmls.PanazReactAddWithoutCTARep;
        return htmls.PanazReactAddWithoutCTA;
      }
    }
  };

  const findAndSetBannerType = () => {
    let bType = getBannerType();
    setBannerType(bType);
    // while (bType === "react" && (adConfig.creative_size.includes('vertical') || adConfig.creative_size.includes('horizontal')) && location.pathname === '/People/dashboard') bType = getBannerType();
    // while (bType === "vertical" && (adConfig.creative_size.includes('react') || adConfig.creative_size.includes('horizontal')) && (location.pathname === '/People/Consultation' || location.pathname === '/People/Procedures')) bType = getBannerType();
    // while( location.pathname === '/People/Diagnosis' && bType!== 'horizontal' && adConfig.creative_size.includes('horizontal')) bType = getBannerType();
    // while( location.pathname === '/People/Prescription' && bType=== 'vertical' && adConfig.creative_size.includes('vertical')) bType = getBannerType();
    // if(location.pathname === '/People/Diagnosis' && bType === 'horizontal') {
    //   const rand = Math.floor(Math.random() * 2) + 1;
    //   if(rand === 1) setBannerType('horizontal');
    //   else setBannerType("horizontal-below");
    // }else
    //   setBannerType(bType);
  }

  const findAndSetDrugType = () => {
    const dType = location.pathname === '/People/dashboard' ? getDrugToShowDashboard() : getDrugToShowConsultation();
    setDrugType(dType);
  }

  useEffect(() => {
    if (!adConfig) return;

    findAndSetDrugType();
    findAndSetBannerType();

    if (location.pathname === '/People/dashboard') setShowAd(adConfig && adConfig.workflowWithAdds ? adConfig.workflowWithAdds.includes("Patient chart") : false);
    if (location.pathname === '/People/Consultation') setShowAd(adConfig && adConfig.workflowWithAdds ? adConfig.workflowWithAdds.includes("Consultation") : false);
    if (location.pathname === '/People/Procedures') setShowAd(adConfig && adConfig.workflowWithAdds ? adConfig.workflowWithAdds.includes("Procedure") : false);
    if (location.pathname === '/People/Diagnosis') setShowAd(adConfig && adConfig.workflowWithAdds ? adConfig.workflowWithAdds.includes("Diagnosis") : false);
    if (location.pathname === '/People/Prescription') setShowAd(adConfig && adConfig.workflowWithAdds ? adConfig.workflowWithAdds.includes("Prescription") : false);
    if (location.pathname === '/People/Billing') setShowAd(adConfig && adConfig.workflowWithAdds ? adConfig.workflowWithAdds.includes("Prescription") : false);
  }, [location.pathname])

  useEffect(() => {
    findAndSetDrugType();
    findAndSetBannerType();
  }, [open])

  const handleClosePopup = () => {
    setOpen(false);
  };


  return (
    <>
      <MobileNavbar />
      <GridDashBoard>
        <div className="desk-visibility">
          <Sidebar config={sidebarConfig} />
          <div className="desk-navbar-wrap">
            <div className="conatiner">
              <Navbar handleSettingClick={() => setOpen(true)} />
            </div>
          </div>
        </div>
        <div className="customeGridArea">
          <div className="conatiner">
            <Header location={location} CustomBanner={location.pathname === "/People/Billing" ? getRandomHoriCreative() : bannerType === "horizontal" && showAd && getRandomHoriCreative()} selectedBanner={selectedBanner} />
            <Grid container style={{marginBottom:"10px"}}>
              <Container className="tab-custom-css">
                <CustomLink
                  activeClassName="TabActive"
                  to="/People/dashboard"
                  onClick={() => handleLinkClick(randomValue)}
                >
                  Dashboard
                </CustomLink>
                <CustomLink
                  activeClassName="TabActive"
                  to="/People/Consultation"
                  onClick={() => handleLinkClick(randomValue)}
                >
                  Consultation
                </CustomLink>
                <CustomLink
                  activeClassName="TabActive"
                  to="/People/Procedures"
                  onClick={() => handleLinkClick(randomValue)}
                >
                  Procedures
                </CustomLink>
                <CustomLink
                  activeClassName="TabActive"
                  to="/People/Diagnosis"
                  onClick={() => handleLinkClick(randomValue)}
                >
                  Diagnosis
                </CustomLink>
                <CustomLink
                  activeClassName="TabActive"
                  to="/People/Prescription"
                  onClick={() => handleLinkClick(randomValue)}
                >
                  Prescription
                </CustomLink>
              </Container>
            </Grid>

            <div>
              <Router
                selectedBanner={selectedBanner}
                setSelectedBanner={onBannerChange}
                verticalCreative={bannerType === 'vertical' && showAd && getRandomVertCreative()}
                reactCreative={bannerType === 'react' && showAd && getRandomReactCreative()}
                horizontalCreative={bannerType === 'horizontal-below' && showAd && getRandomHoriCreative()}
                popupCreative={getRandomHoriCreative()}
              />
            </div>
          </div>
        </div>
        {open && <CustomizePopup open={open} onClose={handleClosePopup} />}
      </GridDashBoard>
    </>
  );
}
